module.exports = __webpack_public_path__ + "img/Dionisie_Fotino_Istoria_Daciei_Tomul_II_Viena_1818.055a41f3.jpg";